import { BaseGroupModal } from './base';
import {
  createGroup,
  resetGroupData,
  setGroupValue
} from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisShowToastr } from '../../../../redux/slices/utils/ui/toastr';
import { useTranslate } from '@tolgee/react';

export const CreateGroupModal: React.FC<any> = ({ show, onHide }) => {
  const { t } = useTranslate();
  const {
    data: { create_group_data, users }
  } = useSelector((state: any) => state.lomavisPostApproval);
  const dispatch = useDispatch();
  const setValue = ({ key, value }) => {
    dispatch(setGroupValue({ key, value }));
  };
  const onDataSave = () => {
    dispatch(createGroup() as any);
    dispatch(resetGroupData() as any);

    lomavisShowToastr(
        t('lomavisPostApproval.createGroup.groupCreated'),
        'success'
    );
    onHide();
  };
  return (
    <BaseGroupModal
      show={show}
      onHide={onHide}
      setValue={setValue}
      groupData={create_group_data}
      onSave={onDataSave}
      users={users}
    />
  );
};
